import { OPEN_DRAWER } from '../constants/drawer';

const initialState = {
  drawer: false,
};

const OpenDrawerReducer = (state = initialState, action) => {
  // console.log("action",action);
  switch (action.type) {
    case OPEN_DRAWER:
      return {
        ...state,
        drawer: action.payload,
      };
    default:
      return state;
  }
};
export default OpenDrawerReducer;
